import React, { useContext } from "react";
import { Image, StyleSheet, View, Text } from "react-native";
import { MaterialCommunityIcons, Ionicons } from "@expo/vector-icons";

import colors from "../config/colors";
import AuthContext from "../auth/context";
import storage from "../auth/storage";

function ViewImageScreen(props) {
  const { user, setUser  } = useContext(AuthContext);    

  return (
    <View style={styles.container}>
      {/* <View style={styles.closeIcon}>
        <MaterialCommunityIcons name="close" color="white" size={35} />
      </View> */}
      <View style={styles.deleteIcon}>
        <Ionicons
        onPress={() => {
          storage.removeToken() 
          setUser('')
        } }
          
          name="create"
          color="white"
          size={45}
        />
      </View>
      <Text style={styles.txtMes}>
        No estas registrado o no cuentass con un perfil,
       registrate o inicia una cuenta a ahora para disfrutar de Fixo completamente.

      </Text>
      {/* <Image
        resizeMode="contain"
        style={styles.image}
        source={require("../assets/a.jpg")}
      /> */}
    </View>
  );
}

const styles = StyleSheet.create({
  closeIcon: {
    position: "absolute",
    top: 100,
    left: 110,
  },
  container: {
    backgroundColor: colors.black,
    flex: 1,
  },
  deleteIcon: {
    position: "absolute",
    top: 200,
    left: 300,
  },
  image: {
    width: "100%",
    height: "100%",
  },
  txtMes:{
    color:colors.white,
    position: "absolute",
    top: 150,
    left: 30,
  }
});

export default ViewImageScreen;
